/**
 * 這台裝置看過哪些開獎的彩帶。每次開獎只放一次。
 *
 * 讀寫都包 try：無痕模式或封鎖網站資料時 localStorage 會丟例外，而彩帶只是裝飾，
 * 最多就是多放幾次。
 */
const SEEN_KEY = "fight-health-reveals-seen-v1";

export function seenReveals(): string[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(SEEN_KEY) ?? "[]");
    return Array.isArray(parsed) ? parsed.filter(id => typeof id === "string") : [];
  } catch {
    return [];
  }
}

export function saveSeenReveals(ids: string[]): void {
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify(ids));
  } catch {
    /* 存不起來就下次再放一次 */
  }
}
